import gql from 'graphql-tag';

const GET_SIGNUP_V2_IMPRESSIONS = gql`
  query GetSignupV2Impressions($signupId: ID!) {
    campaignOrderSignupsWithEvents(where: { id: $signupId }) {
      id
      signUpId
      impressions {
        id
        eventId
        media
        impressionTime
        impressionPublisherPlatform
        impressionPublisherUrl
        impressionPublisher
        impressionPubliserViewed
        impressionPublisherMedia
      }
    }
  }
`;

export default GET_SIGNUP_V2_IMPRESSIONS;
